import React from 'react';
import UpdateRejectedData from '../components/UpdateRejectedDataBody';

function UpdateRejectedDataPage() {
    return <UpdateRejectedData />;
}

export default UpdateRejectedDataPage;